import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "grid w-full p-1",
  style: {"grid-template-columns":"repeat(auto-fit, minmax(160px, 1fr))","grid-gap":"0.75rem"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("ล้าง Filter")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("ออกรายงาน")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommonInput = _resolveComponent("CommonInput")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createBlock(_component_Panel, { class: "area-percent-tReport" }, {
    default: _withCtx(() => [
      _createVNode(_component_Panel, { style: {"max-width":"500px"} }, {
        default: _withCtx(() => [
          _createVNode(_component_Panel, { title: "เลือกวันที่ และกดออกรายงาน เพื่อทำการ Download Report" }, {
            default: _withCtx(() => [
              _createVNode(_component_CommonInput, {
                class: "pt-3 mt-3",
                type: "date-range",
                modelValue: _ctx.filter.range,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filter.range) = $event))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_CommonButton, {
                  small: "",
                  block: "",
                  type: "button",
                  level: "gray",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.range = { from: undefined, to: undefined }))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_CommonButton, {
                  small: "",
                  block: "",
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCSVReport('percentT', { from: _ctx.filter.range.from, to: _ctx.filter.range.to }))),
                  icon: "img/icons/print.png"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}